

































import { Component, Mixins, Prop, Vue } from 'vue-property-decorator'
import { cloneDeep } from 'lodash'
import { Exercise, Routine } from '@/interfaces'
import RoutineList from '@/components/RoutineList.vue'
import RoutineMixin from '@/mixins/RoutineMixin'

@Component({
  components: { RoutineList }
})
export default class RoutinePlayer extends Mixins(RoutineMixin) {
  @Prop({ default: '' }) routineId!: string

  circuitIndex: number = 0
  exerciseIndex: number = 0
  repetitionIndex: number = 0

  get activeCircuit (): any {
    return this.routineCircuits[this.circuitIndex]
  }

  get activeExercise (): any {
    return this.activeCircuit.exercises[this.exerciseIndex]
  }

  get activeRepetition (): any {
    const repetition = cloneDeep(this.activeExercise.repetitions[this.repetitionIndex])

    repetition.weights.female.advanced = Number(repetition.weights.female.advanced)
    repetition.weights.female.beginner = Number(repetition.weights.female.beginner)
    repetition.weights.female.intermediate = Number(repetition.weights.female.intermediate)
    repetition.weights.female.advanced += this.weightOffset
    repetition.weights.female.beginner += this.weightOffset
    repetition.weights.female.intermediate += this.weightOffset

    repetition.weights.male.advanced = Number(repetition.weights.male.advanced)
    repetition.weights.male.beginner = Number(repetition.weights.male.beginner)
    repetition.weights.male.intermediate = Number(repetition.weights.male.intermediate)
    repetition.weights.male.advanced += this.weightOffset
    repetition.weights.male.beginner += this.weightOffset
    repetition.weights.male.intermediate += this.weightOffset

    return repetition
  }

  get activeWeight () {
    return this.activeRepetition.weights[this.$store.state.account.settings.gender][this.$store.state.account.settings.weights]
  }

  navigateBack () {
    this.$router.push({ name: 'routine-info', params: { routineId: this.routine.id } })
  }

  nextExercise () {
    if (this.exerciseIndex < this.activeCircuit.exercises.length - 1) {
      this.setPosition(this.repetitionIndex, this.exerciseIndex + 1, this.circuitIndex)

      return
    }

    if (this.repetitionIndex < this.activeExercise.repetitions.length - 1) {
      this.setPosition(this.repetitionIndex + 1, 0, this.circuitIndex)

      return
    }

    if (this.circuitIndex < this.routineCircuits.length - 1) {
      this.setPosition(0, 0, this.circuitIndex + 1)

      return
    }

    this.navigateBack()
  }

  setPosition (repetitionIndex: number, exerciseIndex: number, circuitIndex: number) {
    this.exerciseIndex = exerciseIndex
    this.repetitionIndex = repetitionIndex
    this.circuitIndex = circuitIndex
  }
}
